import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-circulation-history',
  templateUrl: './circulation-history.component.html',
  styleUrls: ['./circulation-history.component.css']
})
export class CirculationHistoryComponent implements OnInit {

  constructor() { }

  ngOnInit(): void {
  }

}
